export const useIsCypress = () => ({ isCypress: localStorage.getItem('IS_CYPRESS_ENVIRONMENT') === 'true' })
